import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function ProjectSecretValueField({
  value,
  onChange,
  error,
  helper_text,
  mode,
}) {
  const is_edit = mode === 'edit';
  const [value_visible, setValueVisible] = useState(false);

  const toggleValueVisible = () => {
    setValueVisible((prev) => !prev);
  };

  return (
    <TextField
      fullWidth
      margin='normal'
      label='Value'
      type={value_visible ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      error={error}
      helper_text={
        helper_text ||
        (is_edit
          ? 'Enter a new value. The stored secret cannot be displayed.'
          : '')
      }
      autoComplete='new-password'
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label={
                value_visible ? 'hide secret value' : 'show secret value'
              }
              onClick={toggleValueVisible}
              edge='end'
              tabIndex={-1}
            >
              {value_visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
